import { Box, Typography } from '@mui/material';
import React from 'react';
import { RoleId, useCurrentUserQuery } from '../../../services';
import { routeAuthFilter } from '../../../types';
import { DPage, DPageBody } from '../../dum';
import { DashboardProductionChart } from './dashboard-production-chart';
import { TransfersListBlock } from '../management/transfers/transfers/blocks/transfers-list-block';

export function DashboardPage() {
    const { data } = useCurrentUserQuery();
    const currentUser = data?.currentUser;

    // Everyone reaches the dashboard. The transfer tables (Cobranzas + Pagos)
    // both belong to the Expenses (Gastos) domain — reusing the same role
    // hierarchy as the routes, so Super/General/Asistente General see them too.
    const canSee = currentUser ? routeAuthFilter(currentUser) : () => false;
    const canSeeTransfers = canSee({
        roleIds: [RoleId.Expenses, RoleId.ExpensesAssistant],
    });

    return (
        <DPage>
            <DPageBody>
                {/* DPage/DPageBody are `flex: 1; min-height: 0` all the way up to
                    the app shell's Paper — that's what lets a flex child shrink
                    to the space it's given instead of growing to fit its content.
                    Without an explicit scroll boundary HERE, taller-than-usual
                    content (10 rows in each table below) doesn't grow the Paper;
                    it just paints past its themed background with nothing behind
                    it. This box is the scroll boundary: it takes the space the
                    ancestor chain gives it, and scrolls its OWN content instead
                    of spilling past it. */}
                <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
                    {/* Chart — fixed height (Recharts' ResponsiveContainer needs
                        a definite-height ancestor) instead of sharing flex space
                        with the tables below. */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', mb: 3 }}>
                        <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>Producción esta semana</Typography>
                        <Box sx={{ height: { xs: 260, md: 320 } }}>
                            <DashboardProductionChart />
                        </Box>
                    </Box>

                    {/* Tables — transfers (Cobranzas + Pagos) are an
                        Expenses-domain view. Each renders at its natural height
                        (filter + paginator + all rows) instead of being squeezed
                        into a fixed flex share with overflow:hidden — that was
                        clipping rows on shorter screens. Side-by-side on md+,
                        stacked on small screens. */}
                    {canSeeTransfers && (
                        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2 }}>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <TransfersListBlock
                                    scope={{ type: 'transferType', id: 2 }}
                                    title={'Cobranzas'}
                                    storageKey={'DashboardTransfersCobranzas'}
                                />
                            </Box>

                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <TransfersListBlock
                                    scope={{ type: 'transferType', id: 3 }}
                                    title={'Pagos'}
                                    storageKey={'DashboardTransfersPagos'}
                                />
                            </Box>
                        </Box>
                    )}
                </Box>
            </DPageBody>
        </DPage>
    );
}
